import { createSelector } from 'reselect'

import { RootState } from '../store'
export const getLyraTherapyState = (state: RootState) => state?.lyraTherapy

export const getClientDetails = createSelector(
  getLyraTherapyState,
  (lyraTherapyState) => lyraTherapyState?.clientDetails,
)

export const getSelectedClientId = createSelector(
  getClientDetails,
  (clientDetails) => clientDetails?.ltClient.selectedClientId,
)

export const getClientAppointments = createSelector(getClientDetails, (clientDetails) => clientDetails?.appointments)

export const getClientAppointmentDetails = createSelector(
  getClientAppointments,
  (clientAppointments) => clientAppointments?.appointmentDetails,
)

export const getRequestedCaseloadManagementQuarter = createSelector(
  getClientAppointments,
  (clientAppointments) => clientAppointments?.currentCaseloadManagementDashboardQuarter,
)

export const getCurrentQuarterCMDDetailedWeeklyView = createSelector(
  getClientAppointments,
  (clientAppointments) => clientAppointments?.currentQuarterCMDDetailedWeeklyView,
)

export const getClientCurrentSessionCount = createSelector(
  getClientAppointments,
  (clientAppointments) => clientAppointments?.currentSessionCount,
)

export const getClientUnclosedPastAppointments = createSelector(
  getClientAppointments,
  (clientAppointments) => clientAppointments?.unclosedPastAppointments,
)

const getClientAssignments = createSelector(getClientDetails, (clientDetails) => clientDetails?.assignments)

export const getSelectedAssignmentId = createSelector(
  getClientAssignments,
  (clientAssignments) => clientAssignments?.selectedAssignmentId,
)

export const getClientAssignmentResponse = createSelector(
  getClientAssignments,
  (clientAssignments) => clientAssignments?.responseDetails,
)

export const getToastContent = createSelector(getLyraTherapyState, (lyraTherapyState) => lyraTherapyState.toast)
